export const programas = [
    

    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_001.png", // URL de la imagen
        "nompro" : 'Bienestar de Personas Cuidadoras de Personas con Discapacidad',
        "descripcion" : "Para familiares, tutores o personas de apoyo que sean mayores de edad, que se dediquen de tiempo completo al cuidado de personas con discapacidad permanente...",
        "enlace" : "/Programas/Cuidadores",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },
    
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_002.png", // URL de la imagen
        "nompro" : 'Apoyo Para el Bienestar y Desarrollo',
        "descripcion" : "Para personas hidalguenses de 30 a 64 años que habiten en localidades de alta y muy alta marginación, en situación de pobreza extrema...",
        "enlace" : "/Programas/Bienestarydesarrollo",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },
    {
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_003.png", // URL de la imagen
        "nompro" : 'Bienestar de Madres Trabajadoras',
        "descripcion" : "Para madres solteras trabajadoras y madres estudiantes con hijo o hija de 0 a 5 años y 11 meses, sin acceso a los servicios de cuidado y atención infantil...",
        "enlace" : "/Programas/Madrestrabajadoras",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    }, 
    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_004.png", // URL de la imagen
        "nompro" : 'Desarrollo Inclusivo',
        "descripcion" :"Para personas de la comunidad LGBTTTI de los 18 a los 64 años, que cuenten con residencia en Hidalgo, sin acceso a los servicios de salud o atención médica, de las 12 regiones del Estado de Hidalgo...",
        "enlace" : "/Programas/Desarrolloinclusivo",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_005.png", // URL de la imagen
        "nompro" : 'Atención al Pueblo',
        "descripcion" :"Para personas con carencias sociales en los 84 municipios del estado de Hidalgo, mediante asistencia económica o en especie, adaptándose a las necesidades específicas de cada beneficiario...",
        "enlace" : "/Programas/Atencionalpueblo",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_006.png", // URL de la imagen
        "nompro" : 'Bienestar para Personas Artesanas',
        "descripcion" :"Para personas integrantes de colectivos comunitarios de municipios de Alta y Muy Alta marginación...",
        "enlace" : "/Programas/BienestarArtesanos",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

   
    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_007.png", // URL de la imagen
        "nompro" : 'Fomento Artesanal',
        "descripcion" :"Para artesanas y artesanos hidalguenses con radicación mínima de 5 años en el Estado, así como a los ya inscritos en el padrón único de artesanas, artesanos y empresas de la actividad artesanal...",
        "enlace" : "/Programas/Fomentoartesanal",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_008.png", // URL de la imagen
        "nompro" : 'Atención a Personas Migrantes',
        "descripcion" :"Para personas de origen hidalguense o que radiquen en el Estado de Hidalgo de 65 años o más que sean madres o padres de migrantes que han radicado por más de 10 años en los E.U.A...",
        "enlace" : "/Programas/Atencionmigrante",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

     {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_009.png", // URL de la imagen
        "nompro" : 'Subsidio al Servicio de Verificación Vehicular',
        "descripcion" :"Para personas físicas o morales del sector privado, propietarias, poseedoras o conductoras de vehículos de combustión interna matriculados en el Estado de Hidalgo...",
        "enlace" : "/Programas/SubsidioVerificacion",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },


    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_010.png", // URL de la imagen
        "nompro" : 'Atención de las y los Adultos Mayores',
        "descripcion" :"Para el 7.6% (24,010) de las personas mayores que radiquen, estén domiciliadas o en tránsito en el Estado de Hidalgo...",
        "enlace" : "/Programas/Adultosmayores",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/PS_011.png", // URL de la imagen
        "nompro" : 'Atención a la Juventud',
        "descripcion" :"Para jóvenes hidalguenses con edad comprendida entre los 12 a 29 años, dando cobertura a los 84 municipios del Estado de Hidalgo...",
        "enlace" : "/Programas/Juventud",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

   
    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/ROP_001.png", // URL de la imagen
        "nompro" : "Reglas de Operación 2026",
        "descripcion" : "",
        "enlace" : "/Rops2026",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },

    {    
        "imagen": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/H_001.png", // URL de la imagen
        "nompro" : "Información de años anteriores",
        "descripcion" : "",
        "enlace" : "/Programas/Historico",
        "elementos" : [
            {
                // "elemento" : "Reglas de Operación",
                // "url" : "https://www.google.com.mx/?hl=es"
            },
            {
                // "elemento" : "Normatividad",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Trámite en Línea",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Resultado de la Convocatoria",
                // "url" : "https://www.google.com"
            },
            {
                // "elemento" : "Padrón de Personas Beneficiarias",
                // "url" : "https://www.google.com"
            }
        ]
    },


]